import Spinner from "components/Spinner";
import { setNotification } from "features/Notification/notificationSlice";
import React, { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { useNavigate } from "react-router-dom";
import authHeader from "services/auth-header";
import API from "services/axios";
import MProductFiles from "./MProductFiles";
import axios from "axios";
import { truncateString } from "utils/UtilityFuncs";

export default function MProductsAddUpdate({
  formData,
  setFormData,
  isUpdateMode,
  setShowAddModal,
  setProductsData,
  setIsUpdateMode,
  refreshFunc,
}) {
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const user = useSelector((state) => state.user.userInfo);
  /*   All States
   ********************************************* */
  const [loading, setLoading] = useState(false);
  const [sizes, setSizes] = useState([]);
  const [sizesLoading, setSizesLoading] = useState(false);
  const [customProducts, setCustomProducts] = useState([]);
  const [customProductsLoading, setCustomProductsLoading] = useState(false);
  const [fabrics, setFabrics] = useState([]);
  const [fabricsLoading, setFabricsLoading] = useState(false);
  const [productTypes, setProductTypes] = useState([]);

  const [activeTab, setActiveTab] = useState("product");

  /*   All Functions
   ********************************************* */
  // Fetch Custom Products
  const fetchCustomProducts = async () => {
    try {
      setCustomProductsLoading(true);
      const { data } = await API.post(
        "/manufacturer/products/custom-products",
        { limit: 100, page: 1 },
        { headers: authHeader() }
      );
      if (data?.success) {
        setCustomProducts(data.data);
      }
    } catch (err) {
      dispatch(
        setNotification({
          message: err.message,
          type: "error",
        })
      );
    } finally {
      setCustomProductsLoading(false);
    }
  };

  // Fetch Sizes
  const fetchSizes = async () => {
    try {
      setSizesLoading(true);
      const { data } = await API.post(
        "manufacturer/products/sizes",
        { limit: 100, page: 1 },
        { headers: authHeader() }
      );
      if (data?.success) {
        setSizes(data.data);
      }
    } catch (err) {
      dispatch(
        setNotification({
          message: err.message,
          type: "error",
        })
      );
    } finally {
      setSizesLoading(false);
    }
  };

  // Fetch Fabrics
  const fetchFabrics = async () => {
    try {
      setFabricsLoading(true);
      const { data } = await API.post(
        "manufacturer/products/fabrics",
        { limit: 100, page: 1, filterBy: "all" },
        { headers: authHeader() }
      );
      if (data?.success) {
        setFabrics(data.data);
      }
    } catch (err) {
      dispatch(
        setNotification({
          message: err.message,
          type: "error",
        })
      );
    } finally {
      setFabricsLoading(false);
    }
  };

  // Fetch product types
  const fetchProductTypes = async () => {
    try {
      setLoading(true);
      const { data } = await API.post(
        "manufacturer/products/product-types",
        { page: 1, limit: 100, filterBy: "all" },
        { headers: authHeader() }
      );
      if (data.success) {
        setProductTypes(data.data);
      } else {
        dispatch(
          setNotification({
            message: data.message,
            type: "error",
          })
        );
      }
    } catch (err) {
      dispatch(
        setNotification({
          message: err.message,
          type: "error",
        })
      );
    } finally {
      setLoading(false);
    }
  };

  // Handle Custom Product Selection
  const handleCustomProductChange = (e) => {
    const customProductId = e.target.value;
    setFormData({
      ...formData,
      customProductId: customProductId === "" ? null : customProductId,
    });
  };

  // Handle Size Selection
  const handleSizeChange = (sizeId) => {
    const selectedSizes = formData.sizes || [];
    const sizeIndex = selectedSizes.indexOf(sizeId);

    if (sizeIndex === -1) {
      // Add size if not already selected
      setFormData({
        ...formData,
        sizes: [...selectedSizes, sizeId],
      });
    } else {
      // Remove size if already selected
      setFormData({
        ...formData,
        sizes: selectedSizes.filter((id) => id !== sizeId),
      });
    }
  };

  const downloadFile = (fileKey) => {
    axios
      .post(`${process.env.REACT_APP_API_URI}/aws/images`, {
        key: fileKey,
      })
      .then((response) => {
        const url = response.data[0];
        const link = document.createElement("a");
        link.href = url;
        // Opens in a new tab (user, 2026-11-02) instead of downloading.
        link.target = "_blank";
        link.rel = "noopener noreferrer";
        document.body.appendChild(link);
        link.click();
        document.body.removeChild(link);
      })
      .catch((error) => {
        console.log("Error downloading file:", error);
      });
  };

  // Handle form input changes
  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormData((prev) => ({ ...prev, [name]: value }));
  };

  // Adds Button Function
  const AddProductsData = async (e) => {
    e.preventDefault();
    try {
      setLoading(true);

      const _formData = new FormData();
      const file = formData?.file;
      if (file) {
        _formData.append("file", file);
      }

      _formData.append("formData", JSON.stringify(formData));

      const { data } = await API.post("/manufacturer/product", _formData, {
        headers: { ...authHeader(), "Content-Type": "multipart/form-data" },
      });
      if (data?.success) {
        // setProductsData((prev) => [...prev, data?.data]);
        await refreshFunc();
        setFormData({});
        setShowAddModal(false);
        dispatch(
          setNotification({
            message: data?.message,
            type: "success",
          })
        );
      } else {
        dispatch(
          setNotification({
            message: data?.message,
            type: "error",
          })
        );
      }
    } catch (err) {
      dispatch(
        setNotification({
          message: err.message,
          type: "error",
        })
      );
    } finally {
      setLoading(false);
    }

    // setShowAddModal(false);
  };

  // Update Button Function
  const UpdateProductsData = async (e, closeModal) => {
    e.preventDefault();
    try {
      setLoading(true);
      const _formData = new FormData();
      const file = formData?.file;
      if (file) {
        _formData.append("file", file);
      }

      _formData.append("formData", JSON.stringify(formData));

      const { data } = await API.patch("/manufacturer/product", _formData, {
        headers: { ...authHeader(), "Content-Type": "multipart/form-data" },
      });
      if (data?.success) {
        await refreshFunc();
        if (closeModal) {
          setIsUpdateMode(false);
          setShowAddModal(false);
        }
        dispatch(
          setNotification({
            message: data?.message,
            type: "success",
          })
        );
      } else {
        dispatch(
          setNotification({
            message: data?.message,
            type: "error",
          })
        );
      }
    } catch (err) {
      dispatch(
        setNotification({
          message: err.message,
          type: "error",
        })
      );
    } finally {
      setLoading(false);
    }
  };

  /*   All UseEffects
   ********************************************* */ useEffect(() => {
    fetchSizes();
    fetchCustomProducts();
    fetchProductTypes();
    fetchFabrics();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  return (
    <div>
      {loading && <Spinner />}{" "}
      <div className="mb-3">
        <h4>{isUpdateMode ? "Update Product" : "Add Product"}</h4>
      </div>
      <hr className="mt-0 mb-2" />
      <ul className="mb-3 nav nav-tabs nav-bordered border-0 d-flex flex-grow-1">
        <li className="">
          <button
            className={
              activeTab === "product"
                ? `btn btn-primary active bg-primary text-white`
                : "btn bg-white shadow-sm"
            }
            onClick={() => setActiveTab("product")}
          >
            <i className="mdi mdi-settings-outline d-md-none d-block"></i>
            <span className="d-none d-md-block">Product</span>
          </button>
        </li>
        <li className="">
          <button
            className={
              activeTab === "files"
                ? `btn btn-primary active bg-primary text-white`
                : "btn bg-white shadow-sm"
            }
            onClick={() => setActiveTab("files")}
          >
            <i className="mdi mdi-settings-outline d-md-none d-block"></i>
            <span className="d-none d-md-block">Files</span>
          </button>
        </li>
      </ul>
      {activeTab === "product" && (
        <form
          onSubmit={isUpdateMode ? UpdateProductsData : AddProductsData}
          className="row"
        >
          <div className="col-md-6">
            <div className="mb-2">
              <label htmlFor="productTypeId" className="form-label">
                Product Type <span className="text-danger">*</span>
              </label>
              <select
                className="form-select w-100"
                id="productTypeId"
                name="productTypeId"
                value={formData?.productTypeId || ""}
                onChange={handleChange}
                required
              >
                <option value="">Select Product Type</option>
                {productTypes.map((type) => (
                  <option key={type.id} value={type.id}>
                    {type.type}
                  </option>
                ))}
              </select>
            </div>
            <div className="mb-2">
              <label className="form-label font-weight-bold">Style ID</label>
              <div className="">
                <input
                  type="text"
                  value={formData?.styleId || ""}
                  onChange={(e) => {
                    setFormData({
                      ...formData,
                      styleId: e.target.value,
                    });
                  }}
                  className="form-control"
                  placeholder="Enter Style ID"
                />
              </div>
            </div>{" "}
            <div className="mb-2">
              <label className="form-label font-weight-bold">Description</label>
              <div className="">
                <input
                  type="text"
                  value={formData?.desc || ""}
                  onChange={(e) => {
                    setFormData({
                      ...formData,
                      desc: e.target.value,
                    });
                  }}
                  className="form-control"
                  placeholder="Enter Description"
                />
              </div>
            </div>
            {/* Fabric Selection */}
            <div className="mb-2">
              <label htmlFor="fabricId" className="form-label font-weight-bold">
                Fabric
              </label>
              <div className="position-relative">
                <select
                  className="form-control"
                  id="fabricId"
                  name="fabricId"
                  value={formData?.fabricId || ""}
                  onChange={handleChange}
                >
                  <option value="">Select Fabric</option>
                  {fabrics.map((fabric) => (
                    <option key={fabric.id} value={fabric.id}>
                      {fabric.name}
                    </option>
                  ))}
                </select>
                {fabricsLoading && (
                  <div
                    className="position-absolute"
                    style={{ right: "10px", top: "8px" }}
                  >
                    <i className="mdi mdi-loading mdi-spin text-primary"></i>
                  </div>
                )}
              </div>
            </div>
            {/* Custom Product Selection */}
            <div className="mb-2">
              <label className="form-label font-weight-bold">
                Custom Product
              </label>
              <div className="position-relative">
                <select
                  className="form-control"
                  value={formData?.customProductId || ""}
                  onChange={handleCustomProductChange}
                >
                  <option value="">Select Custom Product</option>
                  {customProducts.map((product) => (
                    <option key={product.id} value={product.id}>
                      {product.style} - {product.customDescription}
                    </option>
                  ))}
                </select>
                {customProductsLoading && (
                  <div
                    className="position-absolute"
                    style={{ right: "10px", top: "8px" }}
                  >
                    <i className="mdi mdi-loading mdi-spin text-primary"></i>
                  </div>
                )}
              </div>
              {customProducts.length === 0 && !customProductsLoading && (
                <small className="text-muted">
                  No custom products available.{" "}
                  <span
                    className="text-primary"
                    style={{ cursor: "pointer" }}
                    onClick={() => {
                      navigate(
                        "/manufacturer/products?active=custom_products&filterBy=all&page=1&limit=10"
                      );
                    }}
                  >
                    Add one first
                  </span>
                </small>
              )}
            </div>
            <div className="mb-2">
              <label className="form-label font-weight-bold">
                Product File{" "}
                {formData?.productFile && (
                  <span className="text-success ms-3">
                    {truncateString(
                      formData?.productFile?.split("/").pop(),
                      40
                    )}
                  </span>
                )}
              </label>
              <div className="d-flex align-items-center justify-content-between gap-1">
                <input
                  type="file"
                  onChange={(e) => {
                    setFormData((prev) => ({
                      ...prev,
                      file: e.target.files[0],
                    }));
                  }}
                  className="form-control"
                  placeholder="Enter product link"
                />
                {formData?.productFile && (
                  <div className="d-flex align-items-center gap-1">
                    <button
                      disabled={!formData?.productFile}
                      className="btn btn-sm btn-success"
                      onClick={(e) => {
                        e.preventDefault();
                        downloadFile(formData?.productFile);
                      }}
                    >
                      <i className="mdi mdi-download"></i>
                    </button>
                    <button
                      disabled={!formData?.productFile}
                      className="btn btn-sm btn-danger"
                    >
                      <i className="mdi mdi-delete"></i>
                    </button>
                  </div>
                )}
              </div>
            </div>
          </div>

          {/* Sizes Selection */}
          <div className="col-md-6">
            <div className="mb-0">
              <label className="form-label font-weight-bold mb-2">
                Product Variations
              </label>
              <div className="row">
                {/* Sizes Column */}
                <div className="col-md-12">
                  <div className="card border-0 shadow-sm">
                    <div className="card-header bg-primary bg-opacity-25 border-0 py-1">
                      <h5 className="text-primary">
                        <i className="mdi mdi-ruler mr-1"></i> Sizes
                        {sizesLoading && (
                          <small className="text-muted ml-2">
                            <i className="mdi mdi-loading mdi-spin"></i>{" "}
                            Loading...
                          </small>
                        )}
                      </h5>
                    </div>
                    <div
                      className="card-body p-2"
                      style={{ height: "345px", overflowY: "auto" }}
                    >
                      {sizes.length === 0 && !sizesLoading ? (
                        <div className="text-center text-muted py-2">
                          <i
                            className="mdi mdi-information-outline d-block mb-1"
                            style={{ fontSize: "20px" }}
                          ></i>
                          No sizes available
                        </div>
                      ) : (
                        <div>
                          {sizes.map((size) => (
                            <div className="mb-1" key={size.id}>
                              <div
                                className={`custom-control custom-checkbox ${
                                  (formData.sizes || []).includes(size.id)
                                    ? "bg-light rounded"
                                    : ""
                                }`}
                                style={{
                                  padding: "4px 8px",
                                  transition: "all 0.2s",
                                }}
                              >
                                <input
                                  className="custom-control-input me-2"
                                  type="checkbox"
                                  id={`size-${size.id}`}
                                  checked={(formData.sizes || []).includes(
                                    size.id
                                  )}
                                  onChange={() => handleSizeChange(size.id)}
                                />
                                <label
                                  className="custom-control-label"
                                  htmlFor={`size-${size.id}`}
                                >
                                  {size.name}
                                </label>
                              </div>
                            </div>
                          ))}
                        </div>
                      )}
                    </div>
                    <div className="card-footer bg-white border-top border-1 py-1">
                      <small className="text-muted">
                        Selected: {(formData.sizes || []).length} sizes
                      </small>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>

          {/*   buttons
           ********************************************* */}
          <div className="pt-2 border-top">
            <div className="d-flex justify-content-end">
              <button
                onClick={() => {
                  setShowAddModal(false);
                }}
                className="btn btn-white bg-white btn-sm px-3"
                type="button"
              >
                <i className="mdi mdi-close mr-1"></i> Cancel
              </button>
              <button
                disabled={loading}
                className="btn btn-primary btn-sm ms-1 px-3 ml-2"
                type="submit"
              >
                {isUpdateMode ? (
                  <>
                    <i className="mdi mdi-content-save mr-1"></i> Update
                  </>
                ) : (
                  <>
                    <i className="mdi mdi-plus-circle mr-1"></i> Add
                  </>
                )}
              </button>
              {isUpdateMode && (
                <button
                  onClick={(e) => {
                    e.preventDefault();
                    UpdateProductsData(e, true);
                  }}
                  type="button"
                  className="ms-1 btn btn-secondary"
                >
                  Update & Close
                </button>
              )}
            </div>
          </div>
        </form>
      )}
      {activeTab === "files" && isUpdateMode && (
        <MProductFiles selected={formData} isUpdateMode={isUpdateMode} />
      )}
      {activeTab === "files" && !isUpdateMode && (
        <div className="text-center text-muted py-5">
          <i
            className="mdi mdi-information-outline d-block mb-1"
            style={{ fontSize: "20px" }}
          ></i>
          Please save the product first to manage files.
        </div>
      )}
    </div>
  );
}
